<ng-container>
  <wc-grid #grid gridKey="groupRecordAccessSync" />
</ng-container>
